//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'CopyToClipboard',
	props: { value: String },
	computed: {
		title() {
			return `"${this.value}" kopieren`;
		},
	},
	methods: {
		async copyToClipboard() {
			try {
				const { state } = await navigator.permissions.query({ name: 'clipboard-write' });
				if (state === 'denied') throw new Error('Permission "clipboard-write" is denied!');

				await navigator.clipboard.writeText(this.value);
			} catch (err) {
				console.error(err);
			}
		},
	},
};
